import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'

import { DisenrollmentsRedux } from '../Redux/DisenrollmentsRedux'

const disenrollmentsCrudObservable = createCRUDObservable({
  mainRedux: DisenrollmentsRedux,
  reduxPath: 'disenrollments',
  dataHandlers: {
    get: response => response.data,
  },
})


export const disenrollmentsObservers = Object.assign({}, disenrollmentsCrudObservable.observers, {})

export const disenrollmentsEpic = combineEpics(
  disenrollmentsCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/DisenrollmentsObservable.js